import { render, staticRenderFns } from "./dental.vue?vue&type=template&id=d463d9aa&scoped=true&"
import script from "./dental.vue?vue&type=script&lang=js&"
export * from "./dental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d463d9aa",
  null
  
)

export default component.exports